'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $box = (0, _jquery2.default)('.off-mode');
var cookieName = 'offModeInfoBox';
var boxCloseClass = 'off-mode--closed';
var cookieParam = _cookie2.default.getCookie(cookieName);
var d = new Date();
d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000); // set 7 days, maybe add here some param
var expires = ";expires=" + d.toUTCString();
if (cookieParam != '1') $box.removeClass(boxCloseClass);

var iniBox = function iniBox() {
  if ($box.hasClass(boxCloseClass)) {
    $box.removeClass(boxCloseClass);
  } else {
    $box.addClass(boxCloseClass);
    if (cookieParam === undefined) document.cookie = cookieName + '=1;' + expires + ';path=/';
  }
};

(0, _jquery2.default)(document).on('click', '.off-mode__close, .off-mode__title', iniBox);


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/modules/offlineBox.js
// module id = 961
// module chunks = 0